var map = {
	"./background.png": 396,
	"./banner.png": 309,
	"./copper.png": 383,
	"./discord.png": 257,
	"./gfc.png": 149,
	"./gitBook.png": 258,
	"./logo.png": 1131,
	"./lootex_logo.png": 1132,
	"./opensea.png": 397,
	"./telegram.png": 398,
	"./twitter.png": 259
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1130;